import React from "react";
import PropTypes from "prop-types";
import { CustomDialog, icon } from "../../../../common/components";
import { translate } from "../../../../common/providers";

export default function ProfilePictureConsentDialog({ open, onClose, onConsent }) {
	const handleConsent = () => {
		onConsent();
		onClose();
	};

	return (
		<CustomDialog
			disableBackdropClick
			iconColor="var(--blue-500)"
			iconModel={icon.faInfoCircle}
			maxWidth="sm"
			open={open}
			submitLabel={translate("profile.profile-picture.consent.btn")}
			subTitle={translate("profile.profile-picture.consent.message")}
			title={translate("profile.profile-picture.consent.title")}
			onClose={onClose}
			onSubmit={handleConsent}
		/>
	);
}

ProfilePictureConsentDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onConsent: PropTypes.func.isRequired,
};
